module.exports = __webpack_public_path__ + "static/desktop/img/info-error.43aa0071.svg";